(function () {

    'use strict';

    angular.module('lodash', [])
        .provider('lodash', LodashProvider);

    LodashProvider.$inject = [
        '$windowProvider'
    ];
    function LodashProvider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            $get: function () {
                return $window._ || {};
            }
        };
    }
})();
